/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useRussianPokerStore } from '../../providers/RussianPokerProvider'
import { numberWithSpaces } from '../../utils/number'
import { DepositIcon } from '../Icons'
import { Typography } from '../Typography'

type TotalBetsProps = {
  className?: string
}

const TotalBets: FC<TotalBetsProps> = observer(({ className }) => {
  const { t } = useTranslation()
  const { boxes } = useRussianPokerStore()

  return (
    <div
      css={css`
        display: flex;
        align-items: end;
      `}
      className={className}>
      <Typography as="span" variant="text4">
        {t('totalBets')}:&nbsp;&nbsp;
        {numberWithSpaces(boxes.reduce((acc, box) => acc + box.sumStake, 0))}
        &nbsp;&nbsp;
      </Typography>
      <DepositIcon
        size={{
          mobile: '7px',
          tablet: '12px',
          desktop: '12px',
        }}
        color="gold1"
      />
    </div>
  )
})

export default TotalBets
